import React from "react";
import { Box, Button, Card, CardContent, TextField } from '@material-ui/core';
import styles from './index.module.scss';

const AuthCard = (props: any) => {
    const onClickLogin = () => {
        props.onLogin();
    };

    return (
        <Card variant="outlined" className={styles.container}>
            <CardContent>
                <h1 className={styles.formTitle}>SRM</h1>

                <form className={styles.form} noValidate autoComplete="off">
                    <Box className={styles.formItem}>
                        <TextField className={styles.formItemInput} label="Email" variant="outlined" />
                    </Box>
                    <Box className={styles.formItem}>
                        <TextField className={styles.formItemInput} label="Password" variant="outlined" />
                    </Box>

                    <Box className={styles.actionContainer}>
                        <Button variant="contained"
                                color="primary"
                                id={styles.loginButton}
                                onClick={onClickLogin}>Login</Button>
                    </Box>
                </form>
            </CardContent>
        </Card>
    );
};

export default AuthCard;
